<template>
  <plain-form :can-back="true" @back="toLogin">
    <form-caption v-if="pageTitle" :text="pageTitle" />
    <div>
      当システムでは、お預かりした個人情報について、以下のとおり適正かつ安全に管理・運用することに努めます。
      <ol class="ps-3">
        <li class="mt-4">
          利用目的
          <ol class="terms">
            当システムは、収集した個人情報を、以下の目的のために利用いたします。
            <li class="terms-item">① 重調@CITYのサービス提供、およびサービス向上のため</li>
            <li class="terms-item">② 相談・お問い合わせへの回答のため</li>
            <li class="terms-item">③ 商品・サービス・イベントの案内のため</li>
          </ol>
        </li>
        <li class="mt-4">
          第三者提供
          <ol class="terms">
            当システムは、以下の場合を除いて、個人情報を第三者へ提供することはしません。
            <li class="terms-item">① 法令に基づく場合</li>
            <li class="terms-item">② 公衆衛生の向上・児童の健全な育成のために必要で、本人から同意を得ることが難しい場合</li>
            <li class="terms-item">③ 国の機関や地方公共団体、その委託者などによる法令事務の遂行にあたって協力する必要があり、かつ本人の同意を得ることで事務遂行に影響が生じる可能性がある場合</li>
          </ol>
        </li>
        <li class="mt-4">
          開示請求
          <p>
            個人情報について、ご本人には、開示・訂正・削除・利用停止を請求する権利があります。<br>
            手続きにあたっては、ご本人確認のうえ対応させていただきますが、代理人の場合も可能です。<br>
            詳細については、以下「個人情報相談窓口」へご連絡ください。<br>
            <br>
            [個人情報相談窓口]<br>
            092-724-7910<br>
          </p>
        </li>
      </ol>
    </div>
    <div class="text-center my-3">
      <check-boxes v-model="checked" :options="checkOptions" :invalid="isInvalid" />
      <div class="invalid-feedback">チェックをいれてください</div>
    </div>
    <template #submit-button>
      <use-as-member-button class="px-5" @click="toPage('EmailRegister')" />
      <use-as-guest-button v-if="isGuestAllowed" class="px-5" @click="toPage('GuestRegister')" />
      <use-as-owner-button v-if="isOwnerAllowed" class="px-5" @click="toPage('OwnerRegister')" />
    </template>
  </plain-form>
</template>
<script>
import {mapState} from "vuex";
import PlainForm from '@/views/templates/forms/PlainForm'
import FormCaption from '@/views/atoms/FormCaption'
import CheckBoxes from "@/views/atoms/inputs/CheckBoxes";
import UseAsMemberButton from '@/views/molecules/buttons/UseAsMemberButton'
import UseAsGuestButton from '@/views/molecules/buttons/UseAsGuestButton'
import UseAsOwnerButton from '@/views/molecules/buttons/UseAsOwnerButton'
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent';

export default {
  name: 'PrivacyPolicyAgreement',
  mixins: [AddonLoadPageEvent],
  components: {
    PlainForm,
    FormCaption,
    CheckBoxes,
    UseAsMemberButton,
    UseAsGuestButton,
    UseAsOwnerButton,
  },
  data() {
    return {
      checkOptions: [
        {id: 'checkBox1', text: '上記内容に同意してシステムを利用する'},
      ],
      checked: {
        checkBox1: false,
      },
      isInvalid: false,
    }
  },
  computed: {
    ...mapState('privacy_policy_form', {
       isGuestAllowed: state => state.is_guest_allowed,
       isOwnerAllowed: state => state.is_owner_allowed,
    }),
    pageTitle() {
      return this.$store.state.pageTitle;
    },
    isAgree() {
      return this.checked.checkBox1;
    }
  },
  methods: {
    loadPage() {
      const managementCompanyCode = sessionStorage.getItem('managementCompanyCode');
      if (managementCompanyCode) {
        return this.$store.dispatch('privacy_policy_form/load', {managementCompanyCode: managementCompanyCode});
      }
    },
    toPage(route) {
      if (this.isAgree) {
        this.isInvalid = false;
        return this.$router.push({name: route});
      } else {
        this.isInvalid = true;
      }
    },
    toLogin() {
      const managementCompanyCode = sessionStorage.getItem('managementCompanyCode');
      if (managementCompanyCode) {
        this.$router.push({name: 'Login', query: {mccd: managementCompanyCode}});
      } else {
        this.$router.push({name: 'Login'});
      }
    },
  }
}
</script>

<style scoped>
.terms {
  padding-left: 0;
}
.terms-item {
  list-style: none;
  padding-left: 1.2em;
  text-indent: -1.2em;
}
.terms-item:first-of-type {
  margin-top: 0.5rem;
}
</style>